import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ---------- Sentry (gated on REACT_APP_SENTRY_DSN) ----------
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  try {
    // eslint-disable-next-line global-require
    const Sentry = require("@sentry/react");
    Sentry.init({
      dsn: SENTRY_DSN,
      tracesSampleRate: 0.1,
      sendDefaultPii: false,
      beforeSend(event) {
        // Strip user PII before sending
        if (event.user) {
          delete event.user.email;
          delete event.user.username;
          delete event.user.ip_address;
        }
        return event;
      },
    });
  } catch (e) { /* ignore */ }
}

// ---------- PostHog (gated on REACT_APP_POSTHOG_KEY + cookie consent) ----------
const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";
function _consentAccepted() {
  try { return localStorage.getItem("compliche_cookies") === "accepted"; }
  catch { return false; }
}
if (POSTHOG_KEY && _consentAccepted()) {
  try {
    // eslint-disable-next-line global-require
    const posthog = require("posthog-js").default;
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      persistence: "localStorage",
      autocapture: true,
      mask_all_text: false,
      respect_dnt: true,
    });
    window.__compliche_posthog = posthog;
  } catch (e) { /* ignore */ }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
